import React, { useState } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setActiveDropdown(null);
  };

  const toggleDropdown = (dropdown, e) => {
    if (e) e.preventDefault();
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const handleDropdownClick = (e) => {
    // On mobile, prevent navigation and toggle dropdown
    if (window.innerWidth <= 768) {
      e.preventDefault();
      toggleDropdown('experience');
    }
  };

  return (
    <div className="nav-container">
      <nav>
        <div className="logo">
          <a href="#home" onClick={closeMenu}>Nimisha Thallapally</a>
        </div>
        <i className="fa-solid fa-bars menu-icon" onClick={toggleMenu}></i>
        <ul className={isMenuOpen ? 'active' : ''}>
          <li><a href="#home" onClick={closeMenu}>Home</a></li>
          <li><a href="#about" onClick={closeMenu}>About</a></li>
          <li 
            className={`dropdown ${activeDropdown === 'experience' ? 'active' : ''}`}
            onMouseEnter={() => window.innerWidth > 768 && toggleDropdown('experience')}
            onMouseLeave={() => window.innerWidth > 768 && toggleDropdown(null)}
          >
            <a 
              href="#experience" 
              className="dropdown-toggle"
              onClick={handleDropdownClick}
            >
              Experience <i className={`fas fa-chevron-down ${activeDropdown === 'experience' ? 'rotate' : ''}`}></i>
            </a>
            <ul className={`dropdown-menu ${activeDropdown === 'experience' ? 'show' : ''}`}>
              <li><a href="#experience" onClick={closeMenu}>Work Experience</a></li>
              <li><a href="#extracurricular" onClick={closeMenu}>Leadership</a></li>
              <li><a href="#research" onClick={closeMenu}>Research</a></li>
            </ul>
          </li>
          <li><a href="#projects" onClick={closeMenu}>Projects</a></li>
          <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
        </ul>
        <i 
          className={`fa-solid fa-circle-xmark close-icon ${isMenuOpen ? 'active' : ''}`}
          onClick={closeMenu}
        ></i>
      </nav>
    </div>
  );
};

export default Navbar;
